import React, { useEffect, useState } from 'react'
import images from 'assets/images/Guidelines_page-0001.jpg'
import { Outlet, useNavigate, useParams } from 'react-router-dom'
import Api from 'utils/api'
import sideimg from '../../../assets/images/Abstract Creative Idea Brain Bulb Logo (1).png'

function Useronboard() {
  const pathname = window.location.pathname.split('/')
  const navigate = useNavigate()
  const { accountId } = useParams()
  const [account, setAccount] = useState(null)

  const getAccount = async () => {
    const { response } = await Api(`/account/public/detail/${accountId}`, 'get')
    if (response) {
      console.log('Useronboard fetched account:', response.data)
      setAccount(response.data)
    }
  }

  useEffect(() => { getAccount() }, [])

  return (
    <div className='tw-grid md:tw-h-screen tw-items-stretch md:tw-grid-cols-2 md:tw-p-0 tw-p-5'>
      <div className='md:tw-flex tw-items-center tw-justify-center d:tw-h-screen tw-hidden tw-bg-night'>
        <div className='tw-fixed tw-top-20 tw-left-20'>
          {pathname.length > 2 && (
            <div className='tw-inline-block tw-mb-4'>
              <span onClick={() => navigate(-1)} className='tw-cursor-pointer' style={{ color: 'white' }}>
                ← back
              </span>
            </div>
          )}
        </div>
        <div className='tw-block tw-bg-canvas tw-rounded-2xl tw-px-10 tw-py-8 tw-shadow-pop'>
          <img src={account?.logo || sideimg} className="tw-max-w-[250px] tw-object-contain" alt='' />
        </div>
      </div>

      <div class='tw-flex md:tw-items-center md:tw-justify-center md:tw-px-4 tw-py-8'>
        <div class='md:tw-max-w-sm tw-w-full'>
          <Outlet context={{ account }} />
        </div>
      </div>
    </div>
  )
}

export default Useronboard
